module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-1024x1024-17e33d94a57da41db6351e600f17de6e.png";